import flow from 'lodash/fp/flow'
import property from 'lodash/property'
// property getters
const getId = property('id')
const getProductId = property('pimSyncSourceProductId')
/**
 * atob that works on the server and client side
 */
const atob = (v) => (process.client)
  ? window.atob(v)
  : Buffer.from(v, 'base64').toString('utf-8')
export const parseId = (value) => (value) ? atob(value).split('/').pop() : null
export const getParsedVariantId = flow(getId, parseId)
export const getParsedId = flow(getProductId, parseId)
